import footerLeft from "../img/footer-left.png"
import footerSocial from "../img/fotter-social.png"
import footerSocial2 from "../img/fotter-social2.png"
import footerSocial3 from "../img/fotter-social3.png"


export const Footer = () =>{
    return(
        <footer className="container1 footer flex" > 
            <div id="footer"  className="footer-left">
                <div className="flex-start" >
                    <img src={footerLeft}/>
                    <h3>LaslesVPN</h3>
                </div>
                <p>LaslesVPN is a private virtual network that has unique<br/> features and has high security.</p>
                <div className="flex-start container-social" >
                    <img src={footerSocial}/>
                    <img src={footerSocial2}/>
                    <img src={footerSocial3}/>
                </div>
            </div>

            <div className="footer-right flex" >
                <div className="footer-card">
                    <h3>Product</h3>
                    <p><a href="#" >Download </a></p>
                    <p><a href="#" >Pricing</a></p>
                    <p><a href="#" >Locations</a></p>
                    <p><a href="#" >Server</a></p>
                    <p><a href="#" >Countries</a></p>
                    <p><a href="#" >Blog</a></p>
                </div>

                <div className="footer-card">
                    <h3>Engage</h3>
                    <p><a href="#" >LaslesVPN ?  </a></p>
                    <p><a href="#" >FAQ</a></p>
                    <p><a href="#" >Tutorials</a></p>
                    <p><a href="#" >About Us</a></p>
                    <p><a href="#" >Privacy Policy</a></p>
                    <p><a href="#" >Terms of Service</a></p>
                </div>

                <div className="footer-card">
                    <h3>Earn Money</h3>
                    <p><a href="#" >Affiliate </a></p>
                    <p><a href="#" >Become Partner</a></p>
                </div>
                
        
            </div>
        </footer>
    )
}